import React, {Component, useState, useEffect} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from "underscore";
import moment from "moment";
import { TermsAndPrivacy } from '../../../utils/termsAndPrivacy';


import {
  FormGroup,
  FormCheckbox,
  Modal,
  ModalBody,
  ModalHeader,
  Button
} from "shards-react";
import {reactLocalStorage as Storage} from "reactjs-localstorage";

import './inAppOrder.scss';

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';

import {Redirect} from "react-router-dom";
import ModalLoading from "../../../components/common/ModalLoading";

let eventDay = 60;

// 정기결제(autoPayment) 샵의 useExpiryDate 센티널(2999-12-31) 여부.
// 실제 남은 선결제 기간이 아니므로, 선결제 시작일 승계 계산에서 제외해야 한다.
// (제외하지 않으면 시작일이 2999-12-31이 되어 이용기간이 2999-12-31 ~ 3000-12-31 로 잘못 계산됨)
const isRecurringSentinelDate = (date) => moment(date).year() >= 2999;

@inject(({ teamUser }) => ({ authCheck: teamUser.authCheck, isLogin: teamUser.isLogin, me:teamUser.me,  updateInAppOrder:teamUser.updateInAppOrder, getInAppOrderList: teamUser.getInAppOrderList, checkOrder:teamUser.checkOrder, checkOrderShop: teamUser.checkOrderShop, freeEventApply: teamUser.freeEventApply }))
@inject(({ company }) => ({ getSalesReport: company.getSalesReport, getApplyShop:company.getApplyShop }))
@inject(({ common }) => ({ getDoc: common.getDoc }))

@observer
class InAppOrder extends Component {

  //http://localhost:3000/cafeInAppOrderReturnUrl?order_id=cafe24-20250819-447690430&result=success
  //http://localhost:3000/cafeInAppOrderReturnUrl?order_id=cafe24-20250716-447619425&result=success

  //http://localhost:3000/cafeInAppOrderReturnUrl?order_id=cafe24-20250318-447327123&result=failss
  //https://orvad.owphew.co.kr/cafeInAppOrderReturnUrl?order_id=cafe24-20250318-447327123&result=success

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable salesReport = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);
  @observable isEventFree = false;
  //page
  @observable shops = [];
  @observable targetSales = {};
  @observable shopsObj = {};
  @observable freeShop = [];
  @observable paidShop = [];
  @observable refundShop = [];
  @observable inAppOrders = {};
  @observable currentShop = {};
  @observable isStartup = false;
  @observable isEventAble = true;
  @observable noFreeEvent = false;
  @observable redirectInfo = {
    is: false,
    pathname: '/orderEnd'
  }
  @observable isOnePay = false;
  @observable orderInfo = { };
  @observable orderAddOn = false; // 리뷰 부스터 유료 애드온 선택 여부 (플랜 선택 전 체크)
  @observable orderInfoData = { };
  @observable totalOrderInfo = { };
  // 쇼핑몰 선택 모달 노출 여부 (UX 리뉴얼)
  @observable isShopSelectOpen = false;
  // 약관 모달 — type: 'service' | 'private' | 'noRefund'
  @observable termsModal = {open: false, type: null};
  // 결제갱신 안내 모달
  @observable cardRenewModal = {open: false, shopNo: null};
  // 주문자 정보 확인 완료 여부 — 클릭해야 결제 단계로 진행
  @observable isOrdererConfirmed = false;
  // 신규 고객 전용 이벤트 아코디언 펼침 여부
  @observable isEventExpanded = false;

  @observable InstallationCost = 55000;
  @observable payment = {
    plan: {},
    payType: {},
  };

  // @observable isReOrder = true;
  @observable noRefundAgg = false;
  @observable serviceWillDate = {};
  @observable paymentData = {};

  constructor(props) {
    super(props);
    this.init()
  }


  componentDidUpdate(prevProps, prevState){
    if (prevState !== this.state) {
      // Force re-render if state changed
      this.forceUpdate();
    }
  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : {};
      // 유료/무료 이용중인 (멀티)샵 목록(paidShop/freeShop)을 먼저 로드 — 로딩 해제 전에 완료 보장
      // (미로드 상태에서 "샵 추가하기" 버튼만 있는 빈 화면이 깜빡이는 문제 방지)
      try { await this.getInAppOrder(); } catch (e) { console.warn('getInAppOrder error', e); }
      this.getApplyShop(false);   // 현재 이용중인 샵(currentShop) 로드 완료 시 콜백에서 isLoading 해제
      this.checkOrder();

      // if(this.store.useExpiryDate) {
      //   this.store.isNotExpiryWithinOneMonth = !moment(this.store.useExpiryDate).isBefore(moment().add(1, 'months'));
      // }

      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }

      let getSalesReport = await this.props.getSalesReport({store_id: this.store._id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1});
      this.salesReport = getSalesReport.data;

      let paymentData = await this.props.getDoc('getPaymentData', { store_id:this.teamUser.selStore_id });
      this.paymentData = paymentData.data;

      // let isForceEventStore =  ["from2d"];
      let isForceEventStore =  [];
      if(isForceEventStore.indexOf(this.store.platformId) > -1) {
        this.store.isUseFirstOrder = false;
        this.isEventAble = true;
        this.noFreeEvent = false;
        eventDay = 10000000;
      }
      const dDay = moment(this.store.createdAt).add(eventDay, "days");
      const now = moment();
      const duration = moment.duration(dDay.diff(now));

      if (duration.asSeconds() < 0) {
        this.isEventAble = true;
      }



      // console.log(this.paymentData.ablePlan)

      // test용 this.salesReport.getMonthlySales.orderCount = 1000;
      this.store.useExpiryDateDiffNow = this.store.useExpiryDate ? moment(moment(this.store.useExpiryDate).format('YYYY.MM.DD')).diff(moment(), 'days') : 0;
      this.permissions = this.props.me.permissions;

      this.initOrderInfo();
    }

  };


  getInAppOrder = async (event) => {
    let inAppOrderList = await this.props.getInAppOrderList({page:1, limit:50, store_id: this.store._id, searchParams: {paySuccess: "success"} });
    this.inAppOrders = inAppOrderList.docs;
    const now = moment();

    this.freeShop = [];
    this.paidShop = [];
    this.refundInAppOrders = [];
    for(let i in this.inAppOrders) {
      let inAppOrder = this.inAppOrders[i];
      if(inAppOrder.payType === "free") {
        this.freeShop.push(inAppOrder);
      }
      else {
        if(inAppOrder.paySuccess === "success") {
          // 마지막 결제일(inAppOrderupdatedAt) 기준 30일 사이클로 환불 계산
          const startDate = moment(inAppOrder.inAppOrderupdatedAt);
          let nextBillingDate = moment(startDate).add(30, 'days');
          // 자동결제로 30일이 여러 번 지난 케이스 대비 (방어적)
          while (nextBillingDate.isSameOrBefore(now)) {
            nextBillingDate.add(30, 'days');
          }
          let leftDays = nextBillingDate.diff(now, 'days');
          if (leftDays > 30) leftDays = 30;
          if (leftDays < 0) leftDays = 0;
          inAppOrder.leftDays = leftDays;
          inAppOrder.refund = Math.ceil(inAppOrder.orderAmount / 30 * leftDays);
          if(!inAppOrder.startDate && inAppOrder.orders.length > 0) {
            inAppOrder.startDate  = inAppOrder.orders[0].startDate;
          }
          // 일회결제(자동결제 아님)인데 이용 기간이 이미 만료된 항목은 "현재 유료 이용중"에서 제외
          const isAuto = inAppOrder.automaticPayment === "T";
          const isOneTimeExpired = !isAuto && inAppOrder.endDate && moment(inAppOrder.endDate).isBefore(now);
          if (!isOneTimeExpired) {
            this.paidShop.push(inAppOrder);
          }
          if(isAuto) {
            this.refundInAppOrders.push(inAppOrder);
          }
        }
      }
    }

    // 동일 shopNo에 정기구독 + 일회결제가 모두 있으면 정기구독만 남김
    // (정기구독이 있으면 일회결제는 이미 만료되었거나 무의미한 잔여 레코드로 간주)
    const autoShopNos = new Set(this.paidShop.filter(o => o.automaticPayment === "T").map(o => o.shopNo));
    this.paidShop = this.paidShop.filter(o => o.automaticPayment === "T" || !autoShopNos.has(o.shopNo));

    // this.paidShop = _.filter(this.inAppOrders, function(inAppOrder){
    //   if ( inAppOrder.payType !== "free" && !inAppOrder.isRefunded && inAppOrder.paySuccess === "success" ) {
    //
    //     const startDate = moment(inAppOrder.inAppOrderupdatedAt);
    //     let nextBillingDate = moment(startDate).date(startDate.date());
    //     while (nextBillingDate.isSameOrBefore(now)) {
    //       nextBillingDate.add(1, 'month');
    //     }
    //     inAppOrder.leftDays = nextBillingDate.diff(now, 'days');
    //     inAppOrder.refund = Math.ceil(inAppOrder.orderAmount / moment().daysInMonth() * inAppOrder.leftDays);
    //     return true;
    //   }
    // });
  }

  getApplyShop = async (actSync) => {
    let _this = this;
    let updateStore = {
      store_id: this.teamUser.store._id
    }
    this.props.getApplyShop( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
        _this.isLoading = false;   // 실패해도 로딩 해제(무한 로딩 방지)
      }
      else {
        _this.shops = res.data;
        //todo
        // _this.paidShop = [];
        // for(let i in _this.shops) {
        //   let shop = _this.shops[i];
        //   console.log("shop", shop);
        //   if (moment(shop.useExpiryDate) && moment(shop.useExpiryDate).isAfter(moment())) {
        //     shop.leftDays = moment(shop.useExpiryDate).endOf('month').diff(moment(shop.useExpiryDate), 'days');
        //     shop.refund = Math.ceil(shop.orderAmount / moment().daysInMonth() * shop.leftDays);
        //     _this.paidShop.push(shop);
        //     console.log(_this.paidShop)
        //   }
        // }


        _this.shopsObj = _.indexBy(_this.shops, 'platformShopNo');
        _this.currentShop = _.filter(_this.shops, { platformShopNo: _this.teamUser.selShopNo })[0];
        _this.isLoading = false;   // 현재 이용중인 샵 로드 완료 → 페이지 로딩 해제
        if(actSync) {
          toast('업데이트가 완료 되었습니다.');
        }
      }
    });
  }


  checkOrder = async (shopNo) => {
    let updatedStore = await this.props.checkOrder({store_id: this.store._id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo: 1});
    if(updatedStore.data && updatedStore.data.useExpiryDate) {
      this.store.useExpiryDate = updatedStore.data.useExpiryDate;
      this.store.useExpiryDateDiffNow = moment(moment(this.store.useExpiryDate).format('YYYY.MM.DD')).diff(moment(), 'days')+1;
    }
    if(this.store.useExpiryDateDiffNow < -5) {
      if(this.store.useExpiryDateDiffNow > 0) {
        alert('서비스 사용 기간이 '+this.store.useExpiryDateDiffNow+'일 남았습니다.') ;
      }
      else if(this.store.useExpiryDateDiffNow > -7) {
        alert('서비스 사용 기간이 '+Math.abs(this.store.useExpiryDateDiffNow)+'일 지났습니다. 서비스 연장을 진행해 주세요.') ;
      }
      else if(this.store.useExpiryDateDiffNow > -14) {
        alert('서비스 사용 기간이 '+Math.abs(this.store.useExpiryDateDiffNow)+'일 지났습니다. 일부 기능이 제한됩니다. 정상적인 서비스 사용을 위해 연장을 진행해 주세요.') ;
      }
      else  {
        alert('서비스 사용 기간이 '+Math.abs(this.store.useExpiryDateDiffNow)+'일 지났습니다. 서비스 이용을 위해 연장을 진행해 주세요.') ;
      }
    }
  };


  initOrderInfo = async () => {
    //"email" , "isStartup", "name", "storeName", "teamUser_id", "tel", "userName");
    this.totalOrderInfo = _.pick(this.store, 'name', 'tel', 'email');
    this.totalOrderInfo.store_id = this.store._id;
    this.totalOrderInfo.teamUser_id = this.teamUser.id;
    this.totalOrderInfo.storeName = this.store.name;
    this.totalOrderInfo.userName = this.teamUser.name ? this.teamUser.name : this.store.presidentName;

    this.paymentData.ablePlan = await this.selectMyPlan(this.salesReport);
    this.orderInfo.plan = this.paymentData.ablePlan;
  };

  selectMyPlan = async (data) => {
    let ablePlan = {};

    data.getThreeAverageSales.orderCount = parseInt(data.getThreeAverageSales.orderCount / 3);
    data.getThreeAverageSales.isThreeAverage = true;
    //this.targetSales = data.getThreeAverageSales.orderCount >= data.getMonthlySales.orderCount ? data.getThreeAverageSales : data.getMonthlySales;
    this.targetSales = data.getThreeAverageSales ? data.getThreeAverageSales : data.getMonthlySales;

    if(this.targetSales.orderCount < 1000) {
      ablePlan = this.paymentData.planPd["r1000"];
    }
    else if(this.targetSales.orderCount < 2000) {
      ablePlan = this.paymentData.planPd["r2000"];
    }
    else if(this.targetSales.orderCount < 3000) {
      ablePlan = this.paymentData.planPd["r3000"];
    }
    else if(this.targetSales.orderCount < 4000) {
      ablePlan = this.paymentData.planPd["r4000"];
    }
    else if(this.targetSales.orderCount < 5000) {
      ablePlan = this.paymentData.planPd["r5000"];
    }
    else if(this.targetSales.orderCount < 10000) {
      ablePlan = this.paymentData.planPd["r10000"];
    }
    else if(this.targetSales.orderCount < 20000) {
      ablePlan = this.paymentData.planPd["r20000"];
    }
    else {
      // 5000건 이상인 경우 별도 처리
      ablePlan = null;
    }

    if(ablePlan) {
      this.paymentData.yearPlan = _.clone(ablePlan);
      this.paymentData.yearPlan.price = ablePlan.price * 0.8;
      this.paymentData.yearPlan.payPrice = this.paymentData.yearPlan.price * 12;
    }
    return ablePlan
  }

  onSelectShop = async (shopNo) => {
    this.currentShop = _.filter(this.shops, { platformShopNo: shopNo })[0];
    this.orderInfo.shopNo = shopNo;
    let getSalesReport = await this.props.getSalesReport({store_id: this.store._id, shopNo: shopNo});
    this.salesReport = getSalesReport.data;
    // console.log(this.shops);
    //const selectedShop = _.filter(this.shops, { platformShopNo: shopNo })[0];

    this.currentShopOrder = await this.props.checkOrderShop({store_id: this.store._id, shopNo: shopNo});
    this.paymentData.ablePlan = await this.selectMyPlan(this.salesReport);

    // 정기결제 센티널(2999-12-31)은 남은 기간이 아니므로 승계하지 않고 선결제일(오늘) 기준으로 계산
    if(this.currentShop.useExpiryDate && !isRecurringSentinelDate(this.currentShop.useExpiryDate) && moment(this.currentShop.useExpiryDate).isAfter(moment())) {
      this.orderInfo.startDate = moment(this.currentShop.useExpiryDate);
    }
    else {
      this.orderInfo.startDate = moment();
    }


  };

  onChangeShop = async (event, item) => {
    const { value } = event.target;
    let shopNo = value ? parseInt(value) : 1;
    this.currentShop = _.filter(this.shops, { platformShopNo: shopNo })[0];
    this.orderInfo.shopNo = shopNo;
    let getSalesReport = await this.props.getSalesReport({store_id: this.store._id, shopNo: shopNo});
    this.salesReport = getSalesReport.data;
    // console.log(this.shops);
    //const selectedShop = _.filter(this.shops, { platformShopNo: shopNo })[0];

    this.currentShopOrder = await this.props.checkOrderShop({store_id: this.store._id, shopNo: shopNo});
    this.paymentData.ablePlan = await this.selectMyPlan(this.salesReport);

  };




  // 리뷰 부스터 애드온 단가 — SuperConfig(boosterAddOn)의 단가/할인율/할인 기간 설정 반영
  // 정기(autoPayment)/일시불 할인율 별도 적용, 미설정 시 공통 discountPer 폴백
  // 할인 기간(시작/종료일)이 비어있으면 상시 할인, 종료일 당일까지 할인 적용
  getBoosterPricing = (paymentType) => {
    const cfg = (this.paymentData && this.paymentData.boosterAddOn) ? this.paymentData.boosterAddOn : {};
    const orgPrice = Number(cfg.price) > 0 ? Number(cfg.price) : 10000;
    let rawPer = paymentType === 'autoPayment' ? cfg.discountPerAuto : cfg.discountPerOnce;
    if (rawPer === undefined || rawPer === null || rawPer === '') rawPer = cfg.discountPer;
    const discountPer = Number(rawPer) || 0;
    const now = moment();
    const start = cfg.discountStartDate ? moment(cfg.discountStartDate) : null;
    const end = cfg.discountEndDate ? moment(cfg.discountEndDate).endOf('day') : null;
    const isDiscountActive = discountPer > 0 &&
      (!start || now.isSameOrAfter(start)) &&
      (!end || now.isSameOrBefore(end));
    const price = isDiscountActive ? Math.floor(orgPrice * (100 - discountPer) / 100) : orgPrice;
    return { orgPrice, price, discountPer, isDiscountActive, endDate: cfg.discountEndDate };
  };

  onAddShopToCheckout = async (value, type) => {
    let _this = this;
    this.orderInfo.payment = value;
    this.orderInfo.plan = this.paymentData.ablePlan;
    this.orderInfo.addOn = this.orderAddOn; // 리뷰 부스터 애드온 선택 반영
    let payType = (type && type !== "") ? type : this.orderInfo.payment.type === "autoPayment" ? "autoPayment" : "event";

    if(value.val === "free") {
      this.isOnePay = true;
      this.isEventFree = true;
    }
    else {
      this.isOnePay = false;
      this.isEventFree = false;
    }



    if(!this.totalOrderInfo.payType) {
      //this.totalOrderInfo = _.pick(this.orderInfo, "email" , "isStartup", "name", "storeName", "teamUser_id", "tel", "userName");
      this.totalOrderInfo.payType = payType;

      this.totalOrderInfo.orders = {};
      this.totalOrderInfo.shopNos = [];
      console.log("payType", payType)
      if(payType === "autoPayment") {
        // 구독 취소된 쇼핑몰(shop.cancelledAt 존재 또는 useExpiryDate 만료)은 결제 대상에서 제외
        const isShopActive = (shopNo) => {
          const shop = _this.shopsObj && _this.shopsObj[shopNo];
          if (!shop) return false;
          if (shop.cancelledAt) return false;
          if (shop.useExpiryDate && moment(shop.useExpiryDate).isBefore(moment())) return false;
          return true;
        };

        await Promise.all(this.paidShop.map(async function (paidShop) {
          if(paidShop.orders) {
            paidShop.orders.map( async function (order) {
              if(order.payment.type === "autoPayment" && !_this.totalOrderInfo.orders[order.shopNo] && isShopActive(order.shopNo)) {
                _this.totalOrderInfo.orders[order.shopNo] = _.pick(order, "payment", "plan", "shopNo", "email", "isStartup", "name", "storeName", "teamUser_id", "tel", "userName");
                _this.totalOrderInfo.orders[order.shopNo].isUseOrder = true;

                let getSalesReport = await _this.props.getSalesReport({store_id: _this.store._id, shopNo: order.shopNo});
                getSalesReport = getSalesReport.data;
                _this.totalOrderInfo.orders[order.shopNo].plan = await _this.selectMyPlan(getSalesReport);
                _this.totalOrderInfo.shopNos.push(order.shopNo);
              }
            })
          }
          else {
            let order = paidShop;
            if(order.payment.type === "autoPayment" && !_this.totalOrderInfo.orders[order.shopNo] && isShopActive(order.shopNo)) {
              _this.totalOrderInfo.orders[order.shopNo] = _.pick(order, "payment", "plan", "shopNo", "email", "isStartup", "name", "storeName", "teamUser_id", "tel", "userName");
              _this.totalOrderInfo.orders[order.shopNo].isUseOrder = true;

              let getSalesReport = await _this.props.getSalesReport({store_id: _this.store._id, shopNo: order.shopNo});
              getSalesReport = getSalesReport.data;
              _this.totalOrderInfo.orders[order.shopNo].plan = await _this.selectMyPlan(getSalesReport);
              _this.totalOrderInfo.shopNos.push(order.shopNo);
            }
          }
        }))
      }

    }
    else {
      if(this.totalOrderInfo.payType !== payType) {
        alert("구독결제와 일반결제를 동시에 처리 불가능합니다.");
        return false;
      }
    }
    console.log("totalOrderInfo", this.totalOrderInfo)

    // console.log("orderInfo", this.orderInfo)
    this.totalOrderInfo.orders[this.orderInfo.shopNo] = _.clone(this.orderInfo);

    this.totalOrderInfo.shopNos.push(this.orderInfo.shopNo);

    this.totalOrderInfo.orderAmount = 0;

    Object.keys(this.totalOrderInfo.orders).forEach(function(shopNo) {
      let order = _this.totalOrderInfo.orders[shopNo];
      if(order.payment.period > 1) {
        if(order.payment.type === "discount") {
          order.orderPlanPrice = Math.floor(order.plan.price * ((100-order.payment.discountPer)/100));
          order.orderAmount = order.orderPlanPrice * order.payment.period;
        }
        else {
          order.orderAmount = order.plan.price * (order.payment.period - order.payment.freePeriod);
        }
      }
      else {
        order.orderAmount = order.plan.price;
      }
      // 리뷰 부스터 애드온 (표시용) — 위 플랜 계산식과 동일 형태, 단가는 boosterAddOn 설정(정기/일시불 할인율·기간 반영)
      const boosterPrice = _this.getBoosterPricing(order.payment.type).price;
      order.addOnAmount = 0;
      order.addOnReviewWrite = !!order.addOn;
      if(order.addOn) {
        if(order.payment.period > 1) {
          if(order.payment.type === "discount") {
            order.addOnAmount = Math.floor(boosterPrice * ((100-order.payment.discountPer)/100)) * order.payment.period;
          }
          else {
            order.addOnAmount = boosterPrice * (order.payment.period - order.payment.freePeriod);
          }
        }
        else {
          order.addOnAmount = boosterPrice;
        }
        order.orderAmount += order.addOnAmount;
      }
      _this.totalOrderInfo.orderAmount += order.orderAmount;

      // startDate와 endDate 설정
      // 정기결제 센티널(2999-12-31)은 남은 기간이 아니므로 승계하지 않고 선결제일(오늘) 기준으로 계산
      if(!order.startDate) {
        let shop = _this.shopsObj[shopNo];
        if(shop && shop.useExpiryDate && !isRecurringSentinelDate(shop.useExpiryDate) && moment(shop.useExpiryDate).isAfter(moment())) {
          order.startDate = moment(shop.useExpiryDate);
        } else {
          order.startDate = moment();
        }
      }
      if(!order.endDate) {
        if(order.payment.type === 'autoPayment') {
          order.endDate = moment('2999-12-31');
        } else {
          order.endDate = moment(order.startDate).add(order.payment.period, 'months');
        }
      }
    })

    // console.log("totalOrderInfo", this.totalOrderInfo)
    // console.log("shops", this.shops)
    _this.shops.forEach(shop => {
      if(_this.orderInfo.shopNo === shop.platformShopNo) {
        shop.isDisabled = true;
      }
    })
    if(!this.isOnePay) {
      _this.orderInfo = {};
    }

  };

  onFreeSubmit = async (event) => {
    let _this = this;
    if(!this.totalOrderInfo.serviceAgree) {
      alert('서비스 이용약관을 동의해 주세요.');
      return false;
    }
    else if(!this.totalOrderInfo.privateAgree) {
      alert('개인정보 이용약관을 동의해 주세요.');
      return false;
    }
    else {
      this.totalOrderInfo.shopNo = this.orderInfo.shopNo;
      this.totalOrderInfo.automaticPayment = "F";
      this.totalOrderInfo.payType = "free";

      this.totalOrderInfo.endDate = moment().add(14, 'days');
      this.totalOrderInfo.orderAmount = 0;
      this.totalOrderInfo.orderOrgAmount = 0;
      this.totalOrderInfo.orderSaleAmount = 0;
      this.totalOrderInfo.totalRefundAmount = 0;

      let i = 0;
      this.totalOrderInfo.shopNos = [];
      for(let key in this.totalOrderInfo.orders) {
        let order = this.totalOrderInfo.orders[key];
        let shop = this.shopsObj[key];
        this.totalOrderInfo.shopNos.push(shop.platformShopNo);

        if(i === 0) {
          this.totalOrderInfo.orderName = shop.shopName + "(" + key + "):" + order.plan.name;
          this.totalOrderInfo.orderOrgAmount = 0;
          this.totalOrderInfo.orderAmount = 0;
          this.totalOrderInfo.orderSaleAmount = 0;
        }
        else {
          this.totalOrderInfo.orderName += ", " + shop.shopName + "(" + key + "):" + order.plan.name;
        }
        this.totalOrderInfo.orderOrgAmount += parseInt(order.plan.orgPrice) * parseInt(order.payment.period);
        this.totalOrderInfo.orderAmount += parseInt(order.plan.price) * (parseInt(order.payment.period) - parseInt(order.payment.freePeriod ? order.payment.freePeriod : 0));
        this.totalOrderInfo.orderSaleAmount = this.totalOrderInfo.orderOrgAmount - this.totalOrderInfo.orderAmount;

        order.startDate = moment(this.orderInfo.startDate);
        if(!this.store.isUseFirstOrder) {
          order.endDate = moment(order.startDate).add(order.payment.period, 'months');
        }
        else {
          order.endDate = moment(order.startDate).add(order.payment.period, 'days');
        }

        i++;
      }

      this.totalOrderInfo.refundShop = [];

      let cf = window.confirm('무료를 이용하시면 첫결제 이벤트는 사라집니다. 무료 이용을 진행하시겠습니까?');
      if(cf) {
        this.props.freeEventApply(this.totalOrderInfo, function(res) {

          if(res.data && res.data.endDate) {
            toast('서비스 신청이 완료되었습니다');
            window.location.href = _this.redirectInfo.pathname;
            //_this.redirectInfo.is = true;
          }
          else {
            toast('서비스 신청이 정상적으로 처리되지 않았습니다.');
          }
        });
      }
      else {
        return false;
      }
    }
  };

  onSubmit = async (event) => {
    let _this = this;
    event.preventDefault();
    // if(!this.orderInfo.payment) {
    //   alert('상품을 선택해 주세요.');
    //   return false;
    // }
    // else
    if(!this.totalOrderInfo.serviceAgree) {
      alert('서비스 이용약관을 동의해 주세요.');
      return false;
    }
    else if(!this.totalOrderInfo.privateAgree) {
      alert('개인정보 이용약관을 동의해 주세요.');
      return false;
    }
    else if(this.totalOrderInfo.payType === "event" && !this.noRefundAgg) {
      alert('환불 정책에 동의해 주세요.');
      return false;
    }
    else {

      //기존 orderInfo의 키와 값은 현재 디폴터 샵의 주문을 기준으로 totalOrderInfo에 대응 처리
      // 주문 이름은 기준샵 주문명 외 *건
      // 가격과 관련 된 부분은 총합으로

      this.totalOrderInfo.shopNos = [];
      if(this.totalOrderInfo.orders && Object.keys(this.totalOrderInfo.orders).length > 0) {

        // updateInAppOrder(id: ID, store_id: ID!, shopNo: Int, teamUser_id: ID!, storeName: String, userName: String, tel: String, email: String, orderName: String, payType: String, plan: String, automaticPayment: String,
        //     orderAmount: Int, orderOrgAmount: Int, orderSaleAmount: Int, orderPlanPrice: Int, privateAgree: Boolean, serviceAgree: Boolean, startDate: String, endDate: String, nextPayDate: String, payment: JSON): Response
        let i = 0;
        for(let key in this.totalOrderInfo.orders) {
          let order = this.totalOrderInfo.orders[key];
          let shop = this.shopsObj[key];
          this.totalOrderInfo.shopNos.push(shop.platformShopNo);

          if(i === 0) {
            this.totalOrderInfo.orderName = shop.shopName + "(" + key + "):" + order.plan.name;
            this.totalOrderInfo.orderOrgAmount = 0;
            this.totalOrderInfo.orderAmount = 0;
            this.totalOrderInfo.orderSaleAmount = 0;
          }
          // else if(i === Object.keys(this.totalOrderInfo.orders).length - 1) {
          //   this.totalOrderInfo.orderName += ", " + order.plan.name + ")"
          // }
          else {
            this.totalOrderInfo.orderName += ", " + shop.shopName + "(" + key + "):" + order.plan.name;
          }
          this.totalOrderInfo.orderOrgAmount += parseInt(order.plan.orgPrice) * parseInt(order.payment.period);
          if(parseInt(order.payment.discountPer) > 0) {
            order.orderPlanPrice = Math.floor(order.plan.price * ( (100-order.payment.discountPer) / 100));
            order.orderAmount = order.orderPlanPrice * order.payment.period;
            order.orderOrgAmount = order.plan.price * order.payment.period;
            order.orderSaleAmount = order.orderOrgAmount - order.orderAmount;
          }
          else if(parseInt(order.payment.freePeriod) > 0) {
            order.orderPlanPrice = order.plan.price;
            order.orderAmount = parseInt(order.plan.price) * (parseInt(order.payment.period) - parseInt(order.payment.freePeriod ? order.payment.freePeriod : 0));
          }
          else {
            order.orderPlanPrice = order.plan.price;
            order.orderAmount = parseInt(order.plan.price) * (parseInt(order.payment.period));
          }
          // 리뷰 부스터 유료 애드온 — 플랜과 동일한 기간 계산식. 단가는 boosterAddOn 설정(정기/일시불 할인율·기간 반영), 플랜 할인도 동일 적용.
          const booster = this.getBoosterPricing(order.payment.type);
          order.baseAmount = order.orderAmount;
          order.addOnAmount = 0;
          order.addOnOrgAmount = 0;
          order.addOnReviewWrite = !!order.addOn;
          if(order.addOn) {
            if(parseInt(order.payment.discountPer) > 0) {
              order.addOnAmount = Math.floor(booster.price * ((100-parseInt(order.payment.discountPer))/100)) * parseInt(order.payment.period);
              order.addOnOrgAmount = Math.floor(booster.orgPrice * ((100-parseInt(order.payment.discountPer))/100)) * parseInt(order.payment.period);
            }
            else if(parseInt(order.payment.freePeriod) > 0) {
              order.addOnAmount = booster.price * (parseInt(order.payment.period) - parseInt(order.payment.freePeriod ? order.payment.freePeriod : 0));
              order.addOnOrgAmount = booster.orgPrice * (parseInt(order.payment.period) - parseInt(order.payment.freePeriod ? order.payment.freePeriod : 0));
            }
            else {
              order.addOnAmount = booster.price * parseInt(order.payment.period);
              order.addOnOrgAmount = booster.orgPrice * parseInt(order.payment.period);
            }
            order.orderAmount += order.addOnAmount;
          }
          this.totalOrderInfo.orderAmount += order.orderAmount;
          this.totalOrderInfo.orderOrgAmount += order.addOnOrgAmount; // 애드온 정상가 기준 반영 — 부스터 자체 할인분만 할인 금액에 표시
          this.totalOrderInfo.orderSaleAmount = this.totalOrderInfo.orderOrgAmount - this.totalOrderInfo.orderAmount;

          // startDate가 이미 설정되어 있으면 유지, 없으면 새로 설정
          // 정기결제 센티널(2999-12-31)은 남은 기간이 아니므로 승계하지 않고 선결제일(오늘) 기준으로 계산
          if(!order.startDate) {
            let shop = this.shopsObj[key];
            if(shop && shop.useExpiryDate && !isRecurringSentinelDate(shop.useExpiryDate) && moment(shop.useExpiryDate).isAfter(moment())) {
              order.startDate = moment(shop.useExpiryDate);
            } else {
              order.startDate = moment();
            }
          }
          if(order.payment.type === 'autoPayment') {
            order.endDate = moment('2999-12-31');
          }
          else {
            order.endDate = moment(order.startDate).add(order.payment.period, 'months');
          }


          this.totalOrderInfo.orders[key] = order;
          i++;
        }

        this.totalOrderInfo.refundShop = [];
        this.totalOrderInfo.totalRefundAmount = 0;
        if(this.refundInAppOrders.length > 0) {
          this.refundInAppOrders.forEach(refundShop => {
            // 구독 취소된 샵은 환불 대상에서 제외
            const shop = _this.shopsObj && _this.shopsObj[refundShop.shopNo];
            if (!shop || shop.cancelledAt) return;
            if (shop.useExpiryDate && moment(shop.useExpiryDate).isBefore(moment())) return;

            let updateShop = _.pick(refundShop, 'id', 'shopNo', 'orderName', 'orderAmount', 'orderOrgAmount', 'orderPlanPrice', 'orderSaleAmount', 'paySuccess', 'payType', 'plan', 'endDate', 'platformOrderId', 'refund', 'automaticPayment', 'inAppOrderupdatedAt' );
            _this.totalOrderInfo.refundShop.push(updateShop);
            _this.totalOrderInfo.totalRefundAmount += refundShop.refund;
          })
        }

      }
      else {
        return false;
      }

      if(this.totalOrderInfo.payType === 'autoPayment') {
        this.totalOrderInfo.automaticPayment = 'T';
        this.totalOrderInfo.endDate = '2999-12-31';
      }
      else {
        this.totalOrderInfo.automaticPayment = 'F';
      }

    }


    this.props.updateInAppOrder(this.totalOrderInfo, function(res) {

      if(res.errors && res.errors.length > 0) {
        if(res.errors[0].message === 'fail password') {

        }
        else {
          alert(res.errors[0].message);
        }
      }
      else {
        let name = 'review-widget';
        let specs = 'menubar=no,status=no,toolbar=no';
        let url = res.data.confirmation_url;
        window.open(url, name, specs);

        let timeAfter = 0;
        let iVOrderCheck = setInterval(function() {
          timeAfter = timeAfter+2;
          let isInAppOrderCp = Storage.get('isInAppOrderCp');
          if(isInAppOrderCp === 'end' || timeAfter > 600) {
            clearInterval(iVOrderCheck);
            Storage.remove('isInAppOrderCp');
            _this.props.history.push('/inAppOrderList');
          }
        }, 2000);


        //cafeInAppOrderReturnUrl?order_id=cafe24-20230913-446425016&result=fail
      }

    });

  };


  onChangeValue = async (event) => {
    const { name, value } = event.target;
    this.orderInfo[name] = value;
    // 주문자 정보 필드 변경 시 확인 상태 자동 리셋
    if (['userName', 'tel', 'email'].indexOf(name) !== -1) {
      this.isOrdererConfirmed = false;
    }
  };

  @action confirmOrderer = () => { this.isOrdererConfirmed = true; };

  // 약관 모달 열기/닫기
  openTermsModal = (type) => { this.termsModal = {open: true, type}; };
  closeTermsModal = () => { this.termsModal = {open: false, type: null}; };

  openCardRenewModal = (shopNo) => { this.cardRenewModal = {open: true, shopNo}; };
  closeCardRenewModal = () => { this.cardRenewModal = {open: false, shopNo: null}; };
  confirmCardRenew = () => {
    const shopNo = this.cardRenewModal.shopNo;
    this.closeCardRenewModal();
    if (shopNo != null) this.onSelectShop(shopNo);
  };

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
    }
  };

  render() {
    let _this = this;

    function UseDdayCount(props) {
      let createdAt = _this.store.createdAt;
      const [timeLeft, setTimeLeft] = useState("");

      useEffect(() => {
        const dDay = moment(createdAt).add(eventDay, "days");

        const updateCountdown = () => {
          const now = moment();
          const duration = moment.duration(dDay.diff(now));

          if (duration.asSeconds() > 0) {
            const hours = String(duration.hours()).padStart(2, "0");
            const minutes = String(duration.minutes()).padStart(2, "0");
            const seconds = String(duration.seconds()).padStart(2, "0");

            setTimeLeft(`${hours}:${minutes}:${seconds} 남음`);
          } else {
            return false;
            // setTimeLeft("D-Day Expired!");
          }
        };

        const interval = setInterval(updateCountdown, 1000);

        // 초기 호출
        updateCountdown();

        // 컴포넌트 언마운트 시 인터벌 정리
        return () => clearInterval(interval);
      }, [createdAt]);

      if(timeLeft) {
        return <span className="dday-count">{timeLeft}</span>;
      }
      else {
        setTimeLeft(moment().endOf('month').format('M월 D일까지'));
        return <span className="dday-count expired">{timeLeft}</span>;
      }

    };

    return (
        <>
          {this.redirectInfo.is ? (
              <Redirect to={{pathname: this.redirectInfo.pathname}} />
          ) : (
              <div className="main-content ">
                <PageTitle/>

                {(this.isLogin && this.teamUser.emailId) ? (
                    <>
                      {this.targetSales && this.paymentData ? (
                          <>
                            <div className="order-box">

                              {/* === 페이지 히어로: 신뢰 시그널 === */}
                              <div className="iao-hero iao-hero--compact">
                                <h2 className="iao-hero__title">결제하고 온리플 모든 기능을 사용하세요</h2>
                                <div className="iao-hero__trust">
                                  <span className="iao-hero__trust-item"><FeatherIcon icon="shield" size="13"/> 카페24 안전결제</span>
                                  <span className="iao-hero__trust-item"><FeatherIcon icon="lock" size="13"/> SSL 보안 결제</span>
                                </div>
                              </div>

                              {/* === 진행 단계 표시기 === */}
                              {(() => {
                                const orders = (this.totalOrderInfo && this.totalOrderInfo.orders) ? this.totalOrderInfo.orders : {};
                                const ordersCount = Object.keys(orders).length;
                                const hasPlan = ordersCount > 0;
                                let curStep = 1;
                                if (this.orderInfo && this.orderInfo.shopNo) curStep = 2;
                                if (hasPlan) curStep = 3;
                                if (hasPlan && this.isOrdererConfirmed) curStep = 4;
                                const steps = [
                                  {key: 1, label: '(멀티)샵 선택/추가'},
                                  {key: 2, label: '플랜 선택'},
                                  {key: 3, label: '주문자 정보'},
                                  {key: 4, label: '결제 진행'}
                                ];
                                return (
                                  <div className="iao-steps">
                                    {steps.map((s, idx) => {
                                      const isActive = curStep === s.key;
                                      const isDone = curStep > s.key;
                                      const cls = `iao-step${isActive ? ' iao-step--active' : ''}${isDone ? ' iao-step--done' : ''}`;
                                      return (
                                        <React.Fragment key={s.key}>
                                          <div className={cls}>
                                            <span className="iao-step__circle">{isDone ? '✓' : s.key}</span>
                                            <span className="iao-step__label">{s.label}</span>
                                          </div>
                                          {idx < steps.length - 1 && (
                                            <div className={`iao-step-line${isDone ? ' iao-step-line--done' : ''}`}/>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  </div>
                                );
                              })()}

                              {/*{!this.store.isNotExpiryWithinOneMonth && this.salesReport.getMonthlySales && this.paymentData && this.paymentData.ablePlan ? (*/}

                              <div className={"iao-layout" + ((this.totalOrderInfo && this.totalOrderInfo.orders && Object.keys(this.totalOrderInfo.orders).length > 0) ? " iao-layout--split" : "")}>
                                <div className="iao-layout__main">

                              <div className="section-box basic-info-table">
                                <div className="iao-paid">
                                  <div className="iao-paid__head">
                                    <h3 className="iao-paid__title">
                                      <span className="iao-step-num">1</span>
                                      <FeatherIcon icon="check-circle" size="16"/> 샵 선택/추가
                                    </h3>
                                    {this.totalOrderInfo.payType !== "free" && (this.paidShop.length > 0 || this.freeShop.length > 0) && (
                                      <button type="button"
                                              className="iao-paid__add-btn"
                                              onClick={() => { this.isShopSelectOpen = true; }}>
                                        <FeatherIcon icon="plus-circle" size="13"/>
                                        샵 추가하기
                                      </button>
                                    )}
                                  </div>

                                  {this.freeShop.length > 0 && (
                                    <>
                                      <div className="iao-paid__sub-head">
                                        <span className="iao-paid__sub-title">무료 - 현재 이용중인 (멀티)쇼핑몰</span>
                                        <span className="iao-paid__count">{this.freeShop.length}</span>
                                      </div>
                                      <div className="iao-paid__grid">
                                        {this.freeShop.map((order, i) => {
                                          const shop = this.shopsObj[order.shopNo];
                                          const isAuto = order.automaticPayment === "T";
                                          return (
                                            <div key={`free-${i}`} className="iao-paid__card">
                                              <div className="iao-paid__card-head">
                                                <span className="iao-paid__badge">무료</span>
                                                {shop && (
                                                  <a href={"//" + shop.primaryDomain} target="_blank" rel="noopener noreferrer"
                                                     className="iao-paid__shop">
                                                    {shop.shopName}
                                                    <span className="iao-paid__shop-no">#{order.shopNo}</span>
                                                    <FeatherIcon icon="external-link" size="11"/>
                                                  </a>
                                                )}
                                              </div>
                                              <div className="iao-paid__rows">
                                                <div className="iao-paid__row">
                                                  <span className="iao-paid__row-label">적용 플랜</span>
                                                  <span className="iao-paid__row-value">{order.orderAmount === 0 ? '무료' : order.orderName}</span>
                                                </div>
                                                <div className="iao-paid__row">
                                                  <span className="iao-paid__row-label">이용 기간</span>
                                                  <span className="iao-paid__row-value">
                                                    <FeatherIcon icon="calendar" size="11"/>
                                                    {moment(order.startDate).format('YYYY.MM.DD')}
                                                    {' ~ '}
                                                    {isAuto ? '구독중' : moment(order.endDate).format('YYYY.MM.DD')}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="iao-paid__action iao-paid__action--convert">
                                                <Button size="sm" theme="primary"
                                                        onClick={() => this.onSelectShop(order.shopNo)}>
                                                  <FeatherIcon icon="arrow-up-circle" size="12"/>
                                                  유료전환하기
                                                </Button>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </>
                                  )}
                                  {this.paidShop.length > 0 ? (<>
                                    <div className="iao-paid__sub-head">
                                      <span className="iao-paid__sub-title">현재 유료 이용중인 (멀티)쇼핑몰</span>
                                      <span className="iao-paid__count">{this.paidShop.length}</span>
                                    </div>
                                    <div className="iao-paid__grid">
                                      {this.paidShop.map((order, i) => {
                                        const shop = this.shopsObj[order.shopNo];
                                        const isAuto = order.automaticPayment === "T";
                                        return (
                                          <div key={i} className="iao-paid__card">
                                            <div className="iao-paid__card-head">
                                              <span className={`iao-paid__badge${isAuto ? ' iao-paid__badge--sub' : ''}`}>
                                                {isAuto ? '정기구독' : '일회결제'}
                                              </span>
                                              {shop && (
                                                <a href={"//" + shop.primaryDomain} target="_blank" rel="noopener noreferrer"
                                                   className="iao-paid__shop">
                                                  {shop.shopName}
                                                  <span className="iao-paid__shop-no">#{order.shopNo}</span>
                                                  <FeatherIcon icon="external-link" size="11"/>
                                                </a>
                                              )}
                                            </div>
                                            <div className="iao-paid__rows">
                                              <div className="iao-paid__row">
                                                <span className="iao-paid__row-label">적용 플랜</span>
                                                <span className="iao-paid__row-value">{order.orderAmount === 0 ? '무료' : order.orderName}</span>
                                              </div>
                                              <div className="iao-paid__row">
                                                <span className="iao-paid__row-label">이용 기간</span>
                                                <span className="iao-paid__row-value">
                                                  <FeatherIcon icon="calendar" size="11"/>
                                                  {moment(order.startDate).format('YYYY.MM.DD')}
                                                  {' ~ '}
                                                  {isAuto ? '구독중' : moment(order.endDate).format('YYYY.MM.DD')}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="iao-paid__action">
                                              <Button size="sm" theme="light"
                                                      onClick={() => this.onSelectShop(order.shopNo)}>
                                                <FeatherIcon icon={isAuto ? 'sliders' : 'plus-circle'} size="12"/>
                                                {isAuto ? '업/다운 그레이드 하기' : '연장하기'}
                                              </Button>
                                              {isAuto && (
                                                <Button size="sm" theme="light" className="ml-2"
                                                        onClick={() => this.openCardRenewModal(order.shopNo)}>
                                                  <FeatherIcon icon="credit-card" size="12"/>
                                                  결제갱신
                                                </Button>
                                              )}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </>) : this.freeShop.length === 0 ? (
                                    <div className="iao-paid__empty">
                                      <button type="button"
                                              className="iao-paid__add-btn"
                                              onClick={() => { this.isShopSelectOpen = true; }}>
                                        <FeatherIcon icon="plus-circle" size="13"/>
                                        샵 추가하기
                                      </button>
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              <form onSubmit={e => this.onSubmit(e)}>


                                {this.totalOrderInfo.payType !== "free" && this.orderInfo.shopNo ? (<>
                                  {/* "멀티 쇼핑몰 추가하기" 버튼은 위 paidShop 박스 헤더로 통합되었습니다. */}
                                  <div className="section-box basic-info-table">
                                    <>
                                      <div className="iao-plan-head">
                                        <h3 className="iao-plan-head__title">
                                          <span className="iao-step-num">2</span>
                                          플랜 선택하기
                                        </h3>
                                        <span className="iao-plan-head__sub">월 주문 수 기준 자동 책정</span>
                                        <div className="iao-plan-head__shop">
                                          <FeatherIcon icon="shopping-bag" size="13"/>
                                          <strong>{this.orderInfo.storeName}</strong>
                                          <span className="iao-plan-head__shop-sub">({this.currentShop.shopName})</span>
                                          <span className="iao-plan-head__dot">·</span>
                                          <span className="iao-plan-head__sales-label">{this.targetSales.isThreeAverage ? "월평균" : "최근 한달"} 주문 수</span>
                                          <strong className="iao-plan-head__sales-num">{this.targetSales.orderCount}</strong>
                                          <span className="iao-plan-head__sales-unit">건</span>
                                        </div>
                                      </div>
                                      <div className="section-cont">

                                        {this.targetSales.orderCount >= 20000 ? (
                                            <div className="plan-section" style={{padding: '40px', textAlign: 'center', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '2px solid #e9ecef'}}>
                                              <div style={{fontSize: '24px', marginBottom: '20px'}}><span role="img" aria-label="차트">📊</span></div>
                                              <h4 style={{marginBottom: '15px', color: '#495057'}}>월 주문수 20,000건 이상</h4>
                                              <p style={{marginBottom: '20px', fontSize: '16px', color: '#6c757d', lineHeight: '1.6'}}>
                                                월 주문수가 5,000건 이상인 경우 별도의 견적 문의가 필요합니다.<br/>
                                                상담쳇에서 문의 바랍니다.
                                              </p>
                                              <a
                                                  href={`https://onnomad.co.kr/embed/chat?service=온리플&id=${encodeURIComponent(this.store.platformId || '')}&shopName=${encodeURIComponent(this.store.name || '')}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{
                                                    display: 'inline-block',
                                                    padding: '12px 30px',
                                                    backgroundColor: '#FEE500',
                                                    color: '#000000',
                                                    borderRadius: '6px',
                                                    textDecoration: 'none',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    transition: 'all 0.3s'
                                                  }}
                                                  onMouseOver={(e) => e.target.style.backgroundColor = '#FDD835'}
                                                  onMouseOut={(e) => e.target.style.backgroundColor = '#FEE500'}
                                              >
                                                <span role="img" aria-label="말풍선">💬</span> 상담쳇으로 상담하기
                                              </a>
                                            </div>
                                        ) : (
                                            <div className="plan">
                                              {this.paymentData.ablePlan && (!this.totalOrderInfo.payType || this.totalOrderInfo.payType !== "autoPayment") && (!this.store.isUseFirstOrder && this.isEventAble) ? (
                                                  <div className={"plan-event-accordion" + (this.isEventExpanded ? " is-expanded" : "")}>
                                                    <button type="button"
                                                            className="plan-event-accordion__header"
                                                            aria-expanded={this.isEventExpanded}
                                                            onClick={() => { this.isEventExpanded = !this.isEventExpanded; }}>
                                                    <span className="plan-event-accordion__lead">
                                                      <span className="plan-event-accordion__icon" role="img" aria-label="party">🎉</span>
                                                      <span className="plan-event-accordion__title">신규 고객 전용 찬스! 지금 아니면 놓쳐요!</span>
                                                      <span className="plan-event-accordion__dday"><UseDdayCount /></span>
                                                    </span>
                                                      <span className="plan-event-accordion__cta">
                                                      {this.isEventExpanded ? '접기' : '이벤트 적용받기'}
                                                        <FeatherIcon icon={this.isEventExpanded ? 'chevron-up' : 'chevron-down'} size="16"/>
                                                    </span>
                                                    </button>
                                                    {this.isEventExpanded && (
                                                        <div className="plan-event-accordion__body">
                                                          <div className="plan-section plan-section--event">
                                                            <div className="plan-section-wrap">
                                                              {
                                                                Object.keys(this.paymentData.payTypeFirst).map((key, i) => {
                                                                  if (key === "free" && !this.noFreeEvent) {
                                                                    return (
                                                                        <div className={"plan-item" + ((this.orderInfo.payment && this.orderInfo.payment.val) === key ? " selected": "")} key={i}>
                                                                          <div className="plan-selected">선택됨</div>
                                                                          <div className="plan-item-top">
                                                                            <div className="plan-tag"><span
                                                                                className="plan-tag-txt">14일 무료 이벤트</span></div>
                                                                            <div className="plan-cost">
                                                                              <span className="plan-cost-val">무료</span>
                                                                            </div>
                                                                          </div>
                                                                          <div className="plan-limit-banner">
                                                                            <FeatherIcon icon="alert-triangle" size="12"/>
                                                                            <span>SEO 설정 / 상품별 SEO 등 일부 유료 기능은 <strong>제한</strong>됩니다.</span>
                                                                          </div>
                                                                          <div className="plan-item-content">
                                                                            <ul>
                                                                              <li className="order-list">
                                                                                <div className="order-tit"><span>결제 상품</span></div>
                                                                                <div className="order-cont"><span>14일 무료 이벤트</span></div>
                                                                              </li>
                                                                              <li className="order-list">
                                                                                <div className="order-tit"><span>이용 기간</span></div>
                                                                                <div className="order-cont">
                                                                                  <span>{moment().format('YYYY.MM.DD')}</span>&nbsp;~&nbsp;
                                                                                  <span>{moment().add(14, 'days').format('YYYY.MM.DD')}</span>
                                                                                </div>
                                                                              </li>
                                                                              <li className="order-list">
                                                                                <div className="order-tit"><span>결제 금액</span></div>
                                                                                <div className="order-cont"><span>0</span>원</div>
                                                                              </li>
                                                                            </ul>
                                                                          </div>
                                                                          <div className="plan-item-bottom">
                                                                            <button onClick={event => this.onAddShopToCheckout(this.paymentData.payTypeFirst[key], "free")} className="btn-plan-select" type="button">무료로 사용하기</button>
                                                                          </div>
                                                                        </div>
                                                                    )
                                                                  } else if (key.indexOf("event") > -1 && this.paymentData.payTypeFirst[key].period < 7) {
                                                                    let orderPlanOrgPrice = Math.ceil(this.paymentData.ablePlan.orgPrice * (this.paymentData.payTypeFirst[key].period) / this.paymentData.payTypeFirst[key].period)
                                                                    let orderPlanPrice = Math.ceil(this.paymentData.ablePlan.price * (this.paymentData.payTypeFirst[key].period - this.paymentData.payTypeFirst[key].freePeriod) / this.paymentData.payTypeFirst[key].period)
                                                                    return (
                                                                        <div className={"plan-item" + ((this.orderInfo.payment && this.orderInfo.payment.val) === key ? " selected": "")} key={i}>
                                                                          <div className="plan-selected">선택됨</div>
                                                                          <div className="plan-item-top">
                                                                            <div className="plan-tag"><span
                                                                                className="plan-tag-txt">{this.paymentData.payTypeFirst[key].label}</span>
                                                                            </div>
                                                                            <div className="plan-cost">
                                                                              <span className="discount-cost-val">{Math.ceil((orderPlanOrgPrice - orderPlanPrice) / orderPlanOrgPrice * 100)}%</span>
                                                                              <span className="org-cost-val">{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(orderPlanOrgPrice)}</span>
                                                                              <span
                                                                                  className="plan-cost-val">{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(orderPlanPrice)}</span>원
                                                                              / 월
                                                                            </div>
                                                                          </div>
                                                                          <div className="plan-benefit-banner">주문량이 급증하더라도 추가 비용 없이 이용 가능</div>
                                                                          <div className="plan-refund-banner">
                                                                            <span>결제일 기준 14일 이내 요청 시 전액 환불</span>
                                                                          </div>
                                                                          <div className="plan-item-content">
                                                                            <ul>
                                                                              <li className="order-list">
                                                                                <div className="order-tit"><span>결제 상품</span></div>
                                                                                <div className="order-cont"><span>{this.paymentData.ablePlan.name} - {this.paymentData.payTypeFirst[key].eventName}</span></div>
                                                                              </li>
                                                                              <li className="order-list">
                                                                                <div className="order-tit"><span>이용 기간</span></div>
                                                                                <div className="order-cont">
                                                                                  <span>{moment().format('YYYY.MM.DD')}</span>&nbsp;~&nbsp;
                                                                                  <span>{moment().add(this.paymentData.payTypeFirst[key].period, 'months').format('YYYY.MM.DD')}</span>
                                                                                </div>
                                                                              </li>
                                                                              <li className="order-list">
                                                                                <div className="order-tit"><span>결제 금액</span></div>
                                                                                <div className="order-cont">
                                                                                  <span>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(this.paymentData.ablePlan.price * (this.paymentData.payTypeFirst[key].period - this.paymentData.payTypeFirst[key].freePeriod))}</span>원
                                                                                </div>
                                                                              </li>
                                                                            </ul>
                                                                          </div>
                                                                          <div className="plan-item-bottom">
                                                                            <button onClick={event => this.onAddShopToCheckout(this.paymentData.payTypeFirst[key], "")} className="btn-plan-select" type="button">선택(추가)하기</button>
                                                                          </div>
                                                                        </div>
                                                                    )
                                                                  }
                                                                  return null;
                                                                })
                                                              }
                                                            </div>
                                                            <div className="plan-tip">
                                                              <div className="plan-tip-title">- 이런 사업자가 많이 선택합니다.</div>
                                                              <ul>
                                                                <li>서비스를 장기적으로 활용하며 빠르게 성과를 만들어가고 싶은 경우</li>
                                                                <li>단기간 내 빠른 성장세를 기대하고 있는 경우</li>
                                                                <li>비용 부담을 줄이면서 효율적으로 운영하고 싶은 경우</li>
                                                              </ul>
                                                            </div>
                                                            <div className="plan-desc">
                                                              <ul>
                                                                <li><strong>- 결제일 기준 14일 이내 해지 요청 시 전액 환불됩니다.</strong></li>
                                                                <li><strong>- 주문량이 급증하더라도 추가 비용 없이 패키지 이용기간 동안 이용하실 수 있습니다.</strong></li>
                                                                <li><strong>- 결제일 기준 14일 이후 해지 요청 시, 정상 결제 금액 기준으로 총 사용일수를 계산하여 결제 금액에서 차감 후 환불됩니다.</strong></li>
                                                                <li>- 상기 결제금액은 부가세 포함 금액입니다.</li>
                                                                <li>- 해당 이벤트 기간 동안 주문수가 달라져도 추가 결제되지 않습니다.</li>
                                                                <li>- ‘14일 무료 이벤트’는 기본 기능을 14일간 체험할 수 있는 플랜이며, <strong>SEO 설정 / 상품별 SEO 등 일부 유료 기능은 제한</strong>됩니다. (전체 기능 이용은 유료 플랜 결제 후 가능합니다.)</li>
                                                              </ul>
                                                            </div>
                                                          </div>
                                                        </div>
                                                    )}
                                                  </div>
                                              ) : null}
                                              {this.paymentData.ablePlan && Object.keys(this.paymentData.payType).map((key, i) => {
                                                let item = this.paymentData.payType[key];
                                                {
                                                  let orderPlanPrice = Math.floor(this.paymentData.ablePlan.price * (item.discountPer ? (100 - item.discountPer) : 100) / 100);
                                                  let orderAmount = orderPlanPrice * item.period;
                                                  if (!this.totalOrderInfo.payType || (this.totalOrderInfo.payType === "autoPayment" && item.type === "autoPayment") || (this.totalOrderInfo.payType !== "autoPayment" && item.type !== "autoPayment") || item.val.indexOf('discount_') > -1) {
                                                    return (
                                                        <div key={i} className="plan-section">
                                                          <div className="plan-item-tit"><span role="img" aria-label="반짝임">✨</span>{item.label} {item.discountPer > 0 ? (
                                                              <span className="text-danger">{item.discountPer}% 또 할인</span>) : null}
                                                          </div>
                                                          <div className="plan-section-wrap">
                                                            <div
                                                                className={"plan-item" + ((this.orderInfo.payment && this.orderInfo.payment.val) === item.val ? " selected" : "")}>
                                                              <div className="plan-selected">선택됨</div>
                                                              <div className="plan-item-top">
                                                                <div className="plan-tag"><span
                                                                    className="plan-tag-txt">{this.paymentData.ablePlan.name}</span>
                                                                </div>
                                                                <div className="plan-cost">
                                                                  <span className="discount-cost-val">{Math.ceil((this.paymentData.ablePlan.orgPrice - orderPlanPrice) / this.paymentData.ablePlan.orgPrice * 100)}%</span>
                                                                  <span className="org-cost-val">{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(this.paymentData.ablePlan.orgPrice)}</span>
                                                                  <span className="plan-cost-val">{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(orderPlanPrice)}</span>원 / 월
                                                                </div>
                                                                {/*<div className="plan-cost-sub">(월 <span className="plan-cost-val">16,450</span>원에 이용)</div>*/}
                                                              </div>
                                                              {item.val !== "regular" && (
                                                                  <div className="plan-benefit-banner">주문량이 급증하더라도 추가 비용 없이 이용 가능</div>
                                                              )}
                                                              {item.val !== "regular" && (
                                                                  <div className="plan-limit-banner">
                                                                    <FeatherIcon icon="alert-circle" size="12"/>
                                                                    <span>일시불 결제 상품은 결제 완료 후 <strong>환불이 불가</strong>합니다.</span>
                                                                  </div>
                                                              )}
                                                              <div className="plan-item-content">
                                                                {item.val === "regular" ? (
                                                                    <ul>
                                                                      <li className="order-list">
                                                                        <div className="order-tit">
                                                                          <span>결제 상품</span>
                                                                        </div>
                                                                        <div className="order-cont">
                                                                          <span>{this.paymentData.ablePlan.name} - 월 정기 결제</span>
                                                                        </div>
                                                                      </li>
                                                                      <li className="order-list">
                                                                        <div className="order-tit">
                                                                          <span>이용 기간</span>
                                                                        </div>
                                                                        <div className="order-cont">
                                                                          <span>{moment().format('YYYY.MM.DD')}</span>&nbsp;~&nbsp;
                                                                          <span>해지 시까지</span>
                                                                        </div>
                                                                      </li>
                                                                      <li className="order-list">
                                                                        <div className="order-tit">
                                                                          <span>결제 금액</span>
                                                                        </div>
                                                                        <div className="order-cont">
                                                                          <span>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(orderPlanPrice)}</span>원
                                                                        </div>
                                                                      </li>
                                                                    </ul>) : (
                                                                    <ul>
                                                                      <li className="order-list">
                                                                        <div className="order-tit">
                                                                          <span>결제 상품</span>
                                                                        </div>
                                                                        <div className="order-cont">
                                                                          <span>{this.paymentData.ablePlan.name} - {item.label}</span>
                                                                        </div>
                                                                      </li>
                                                                      <li className="order-list">
                                                                        <div className="order-tit">
                                                                          <span>이용 기간</span>
                                                                        </div>
                                                                        <div className="order-cont">
                                                                          <span>{moment(this.orderInfo.startDate).format('YYYY.MM.DD')}</span>&nbsp;~&nbsp;
                                                                          <span>{moment(this.orderInfo.startDate).add(1, "years").format('YYYY.MM.DD')}</span>
                                                                        </div>
                                                                      </li>
                                                                      <li className="order-list">
                                                                        <div className="order-tit">
                                                                          <span>결제 금액</span>
                                                                        </div>
                                                                        <div className="order-cont">
                                                                          <span>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(orderAmount)}</span>원
                                                                        </div>
                                                                      </li>
                                                                    </ul>
                                                                )}

                                                              </div>
                                                              <div className="plan-item-bottom">
                                                                <button
                                                                    onClick={event => this.onAddShopToCheckout(this.paymentData.payType[item.val], "")}
                                                                    className="btn-plan-select" type="button">선택(추가)하기
                                                                </button>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="plan-tip">
                                                            <div className="plan-tip-title">- 이런 사업자가 많이 선택합니다.</div>
                                                            {item.val === "regular" ? (
                                                                <ul>
                                                                  <li>초기 비용 부담 없이 가볍게 시작하고 싶은 경우</li>
                                                                  <li>월 주문량이 일정하여 안정적으로 운영 중인 경우</li>
                                                                </ul>
                                                            ) : (
                                                                <ul>
                                                                  <li>서비스를 장기적으로 활용하며 빠르게 성과를 만들어가고 싶은 경우</li>
                                                                  <li>단기간 내 빠른 성장세를 기대하고 있는 경우</li>
                                                                  <li>비용 부담을 줄이면서 효율적으로 운영하고 싶은 경우</li>
                                                                </ul>
                                                            )}
                                                          </div>
                                                          <div className="plan-desc">
                                                            <ul>
                                                              <li><strong>- 기준 주문수 이상이 될 경우<br/>해당 구독 결제 취소 후 주문수에 맞는 재구독
                                                                진행을 하셔야 합니다.</strong></li>
                                                              {item.val !== "regular" && (
                                                                  <li><strong>- 일시불 결제 상품은 결제 완료 후 환불이 불가합니다.</strong></li>
                                                              )}
                                                              <li>- 중도 해지 시 결제한 이용 기간까지 사용이 가능합니다.</li>
                                                              <li>- 상기 결제금액은 부가세 포함 금액입니다.</li>
                                                            </ul>
                                                          </div>
                                                        </div>
                                                    )
                                                  }
                                                }
                                                return null;
                                              })}
                                              {/* 리뷰 부스터 유료 애드온 — 플랜 상단 단독 배치 (추가 옵션, .booster-addon order:-1) */}
                                              <div className="booster-addon">
                                                <div className="booster-addon__eyebrow">
                                                  <FeatherIcon icon="plus-circle" size="13"/>
                                                  <span>추가 옵션 · 원하실 때만 선택하세요</span>
                                                </div>
                                                {(() => {
                                                  const bpAuto = this.getBoosterPricing('autoPayment');
                                                  const bpOnce = this.getBoosterPricing('discount');
                                                  const anyDiscount = bpAuto.isDiscountActive || bpOnce.isDiscountActive;
                                                  const fmt = (n) => new Intl.NumberFormat('ko-KR').format(n);
                                                  const endDate = bpAuto.endDate || bpOnce.endDate;
                                                  return (
                                                    <div className={"booster-card" + (this.orderAddOn ? " is-selected" : "")}
                                                         role="button" tabIndex={0} aria-pressed={this.orderAddOn}
                                                         onClick={() => { this.orderAddOn = !this.orderAddOn; }}
                                                         onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.orderAddOn = !this.orderAddOn; } }}>
                                                      {/* 할인 기간 리본 — 카드 상단 전체 폭 */}
                                                      {anyDiscount && (
                                                        <div className="booster-card__ribbon">
                                                          <FeatherIcon icon="clock" size="15"/>
                                                          {endDate ? (
                                                            <span><strong>{moment(endDate).format('M월 D일')}까지</strong> 할인 진행중</span>
                                                          ) : (
                                                            <span>할인 진행중</span>
                                                          )}
                                                        </div>
                                                      )}
                                                      <div className="booster-card__icon"><FeatherIcon icon="zap" size="24"/></div>
                                                      <div className="booster-card__body">
                                                        <div className="booster-card__head">
                                                          <span className="booster-card__title">리뷰 부스터</span>
                                                          <span className="booster-card__badge">PRO</span>
                                                        </div>
                                                        <div className="booster-card__desc">리뷰 대량 등록·복사·상품 그룹화로 리뷰를 더 빠르게 쌓아보세요.</div>
                                                        <ul className="booster-card__features">
                                                          <li><FeatherIcon icon="upload" size="11"/> 대량 등록</li>
                                                          <li><FeatherIcon icon="copy" size="11"/> 리뷰 복사</li>
                                                          <li><FeatherIcon icon="layers" size="11"/> 상품 그룹화</li>
                                                        </ul>
                                                      </div>
                                                      <div className="booster-card__price">
                                                        {anyDiscount ? (
                                                          <div className="booster-card__price-modes">
                                                            <div className="booster-card__price-mode">
                                                              <span className="booster-card__price-mode-label">정기</span>
                                                              {bpAuto.isDiscountActive && (
                                                                <>
                                                                  <span className="booster-card__price-discount">{bpAuto.discountPer}%</span>
                                                                  <span className="booster-card__price-org">{fmt(bpAuto.orgPrice)}</span>
                                                                </>
                                                              )}
                                                              <span className="booster-card__price-val booster-card__price-val--sm">{fmt(bpAuto.price)}</span>
                                                              <span className="booster-card__price-cur">원</span>
                                                              <span className="booster-card__price-unit">/월</span>
                                                            </div>
                                                            <div className="booster-card__price-mode">
                                                              <span className="booster-card__price-mode-label">일시불</span>
                                                              {bpOnce.isDiscountActive && (
                                                                <>
                                                                  <span className="booster-card__price-discount">{bpOnce.discountPer}%</span>
                                                                  <span className="booster-card__price-org">{fmt(bpOnce.orgPrice)}</span>
                                                                </>
                                                              )}
                                                              <span className="booster-card__price-val booster-card__price-val--sm">{fmt(bpOnce.price)}</span>
                                                              <span className="booster-card__price-cur">원</span>
                                                              <span className="booster-card__price-unit">/월</span>
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <div className="booster-card__price-row">
                                                            <span className="booster-card__price-val">+{fmt(bpAuto.price)}</span>
                                                            <span className="booster-card__price-cur">원</span>
                                                            <span className="booster-card__price-unit">/월</span>
                                                          </div>
                                                        )}
                                                        <span className="booster-card__price-note">정기 월 추가 · 일시불은 ×개월수</span>
                                                      </div>
                                                      {/* 선택 버튼 — 카드 전체 너비 */}
                                                      <span className="booster-card__toggle">
                                                        {this.orderAddOn && <FeatherIcon icon="check" size="14"/>}
                                                        {this.orderAddOn ? '선택됨' : '선택(추가)하기'}
                                                      </span>
                                                    </div>
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                        )}
                                      </div>

                                    </>
                                  </div>

                                </>) : <></>}


                                {this.totalOrderInfo.orders && Object.keys(this.totalOrderInfo.orders).length > 0 ? (
                                    <>

                                      {this.totalOrderInfo.payType === "autoPayment" ? (
                                          <div className={"section-box basic-info-box" + (_this.totalOrderInfo.shopNos.length > 0 ? " noticeably" : "")} >
                                            <div className="iao-detail">
                                              <div className="iao-detail__head">
                                                <h3 className="iao-detail__title">
                                                  <FeatherIcon icon="repeat" size="16"/> 정기 결제 상세
                                                  <span className="iao-detail__count-badge">{_this.totalOrderInfo.shopNos.length}</span>
                                                </h3>
                                              </div>
                                              <p className="iao-detail__notice">
                                                <strong>기존 구독 결제는 환불 처리</strong>되며 새로운 구독 결제로 다시 결제됩니다.
                                              </p>
                                              <div className="iao-detail__list">
                                                {Object.keys(this.totalOrderInfo.orders).map((key, i) => {
                                                  const orderInfo = this.totalOrderInfo.orders[key];
                                                  if(orderInfo.isUseOrder && orderInfo.plan) {
                                                    return (
                                                      <div key={`use-${i}`} className="iao-detail__item iao-detail__item--existing">
                                                        <div className="iao-detail__item-info">
                                                          <div className="iao-detail__item-row1">
                                                            <span className="iao-detail__tag iao-detail__tag--existing">현재 이용중</span>
                                                            <span className="iao-detail__item-shop-name">{this.shopsObj[orderInfo.shopNo].shopName}</span>
                                                          </div>
                                                          <div className="iao-detail__item-row2">
                                                            <span className="iao-detail__item-plan-name">{orderInfo.plan.name}</span>
                                                          </div>
                                                        </div>
                                                        <div className="iao-detail__item-amount">
                                                          <span className="num">{new Intl.NumberFormat('ko-KR').format(orderInfo.plan.price)}</span>
                                                          <span className="unit">원 / 월</span>
                                                        </div>
                                                      </div>
                                                    )
                                                  }
                                                  return null;
                                                })}
                                                {Object.keys(this.totalOrderInfo.orders).map((key, i) => {
                                                  const orderInfo = this.totalOrderInfo.orders[key];
                                                  if(!orderInfo.isUseOrder && orderInfo.plan) {
                                                    return (
                                                      <div key={`new-${i}`} className="iao-detail__item iao-detail__item--new">
                                                        <div className="iao-detail__item-info">
                                                          <div className="iao-detail__item-row1">
                                                            <span className="iao-detail__tag iao-detail__tag--new">신규 추가</span>
                                                            <span className="iao-detail__item-shop-name">{this.shopsObj[orderInfo.shopNo].shopName}</span>
                                                          </div>
                                                          <div className="iao-detail__item-row2">
                                                            <span className="iao-detail__item-plan-name">{orderInfo.plan.name}</span>
                                                          </div>
                                                        </div>
                                                        <div className="iao-detail__item-amount">
                                                          <span className="num">{new Intl.NumberFormat('ko-KR').format(orderInfo.orderAmount)}</span>
                                                          <span className="unit">원 / 월</span>
                                                        </div>
                                                      </div>
                                                    )
                                                  }
                                                  return null;
                                                })}
                                              </div>

                                              {/* 환불 sub-section — 환불 금액이 0보다 큰 항목만 표시 */}
                                              {(() => {
                                                const refundList = (this.refundInAppOrders || []).filter(r => Number(r.refund) > 0);
                                                if (refundList.length === 0) return null;
                                                return (
                                                <>
                                                  <div className="iao-detail__sub-divider"/>
                                                  <div className="iao-detail__sub-head">
                                                    <h4 className="iao-detail__sub-title">
                                                      <FeatherIcon icon="rotate-ccw" size="14"/> 예상 환불 금액 상세
                                                    </h4>
                                                    <span className="iao-detail__sub-hint">기존 구독은 취소·환불 처리되며 정상가 기준으로 환산됩니다.</span>
                                                    <span className="iao-detail__sub-hint" style={{color: '#dc3545'}}>
                                                      * 해당 금액은 예상 환불 금액으로 실제 환불 금액과 다를 수 있습니다.
                                                    </span>
                                                    <a className="iao-detail__sub-link"
                                                       href="https://onnomad.co.kr/manual/onreple_guide?ch=6968913a42b69734a5432550&sec=69ae784b3ae08be6f4790f40"
                                                       target="_blank"
                                                       rel="noopener noreferrer">
                                                      환불 안내 — 메뉴얼 페이지 3번 항목 확인
                                                      <FeatherIcon icon="external-link" size="11"/>
                                                    </a>
                                                  </div>
                                                  <div className="iao-detail__list">
                                                    {refundList.map((refundShop, i) => (
                                                      <div key={`refund-${i}`} className="iao-detail__item iao-detail__item--refund">
                                                        <div className="iao-detail__item-info">
                                                          <div className="iao-detail__item-row1">
                                                            <span className="iao-detail__tag iao-detail__tag--refund">예상 환불</span>
                                                            <span className="iao-detail__item-shop-name">{refundShop.shop.shopName}</span>
                                                          </div>
                                                          <div className="iao-detail__item-row2">
                                                            <span className="iao-detail__item-plan-name">{refundShop.orderName}</span>
                                                          </div>
                                                        </div>
                                                        <div className="iao-detail__item-amount iao-detail__item-amount--refund">
                                                          <span className="iao-detail__item-amount-label">예상 환불 금액</span>
                                                          <span className="num">-{new Intl.NumberFormat('ko-KR').format(refundShop.refund)}</span>
                                                          <span className="unit">원</span>
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                </>
                                                );
                                              })()}

                                              <div className="iao-detail__total">
                                                <span className="iao-detail__total-label">월 구독 결제 금액</span>
                                                <span className="iao-detail__total-value">
                                                  {new Intl.NumberFormat('ko-KR').format(this.totalOrderInfo.orderAmount)}<span className="unit">원 / 월</span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                      ) : (
                                          <div className={"section-box basic-info-box" + (_this.totalOrderInfo.shopNos.length > 0 ? " noticeably" : "")} >
                                            {this.totalOrderInfo.payType === "free" ? (
                                              <div className="iao-detail">
                                                <div className="iao-detail__head">
                                                  <h3 className="iao-detail__title">
                                                    <FeatherIcon icon="gift" size="16"/> 무료 사용 신청
                                                  </h3>
                                                </div>
                                                <div className="iao-detail__list">
                                                  {Object.keys(this.totalOrderInfo.orders).map((key, i) => {
                                                    const orderInfo = this.totalOrderInfo.orders[key];
                                                    if(!orderInfo.isUseOrder) {
                                                      return (
                                                        <div key={i} className="iao-detail__item iao-detail__item--new">
                                                          <div className="iao-detail__item-info">
                                                            <div className="iao-detail__item-row1">
                                                              <span className="iao-detail__tag iao-detail__tag--new">무료 신청</span>
                                                              <span className="iao-detail__item-shop-name">{this.shopsObj[orderInfo.shopNo].shopName}</span>
                                                            </div>
                                                            <div className="iao-detail__item-row2">
                                                              <span className="iao-detail__item-period">
                                                                <FeatherIcon icon="calendar" size="11"/>
                                                                {moment().format('YYYY.MM.DD')} ~ {moment().add(14, 'days').format('YYYY.MM.DD')} (14일)
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className="iao-detail__item-amount">
                                                            <span className="num">무료</span>
                                                          </div>
                                                        </div>
                                                      )
                                                    }
                                                    return null;
                                                  })}
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="iao-detail">
                                                <div className="iao-detail__head">
                                                  <h3 className="iao-detail__title">
                                                    <FeatherIcon icon="credit-card" size="16"/> 결제 상세
                                                    <span className="iao-detail__count-badge">{_this.totalOrderInfo.shopNos.length}</span>
                                                  </h3>
                                                </div>
                                                <p className="iao-detail__notice">
                                                  일시불 결제는 결제 완료 후 <strong>환불이 불가</strong>합니다. 결제 전 플랜과 이용 기간을 다시 확인해 주세요.
                                                </p>
                                                <div className="iao-detail__list">
                                                  {Object.keys(this.totalOrderInfo.orders).map((key, i) => {
                                                    const orderInfo = this.totalOrderInfo.orders[key];
                                                    if(!orderInfo.isUseOrder) {
                                                      return (
                                                        <div key={i} className="iao-detail__item iao-detail__item--new">
                                                          <div className="iao-detail__item-info">
                                                            <div className="iao-detail__item-row1">
                                                              <span className="iao-detail__tag iao-detail__tag--new">신규 결제</span>
                                                              <span className="iao-detail__item-shop-name">{this.shopsObj[orderInfo.shopNo].shopName}</span>
                                                            </div>
                                                            <div className="iao-detail__item-row2">
                                                              <span className="iao-detail__item-plan-name">{orderInfo.plan.name} - {orderInfo.payment.label}</span>
                                                              <span className="iao-detail__item-period">
                                                                <FeatherIcon icon="calendar" size="11"/>
                                                                {moment(orderInfo.startDate).format('YYYY.MM.DD')} ~ {moment(orderInfo.endDate).format('YYYY.MM.DD')}
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className="iao-detail__item-amount">
                                                            <span className="num">{new Intl.NumberFormat('ko-KR').format(orderInfo.orderAmount)}</span>
                                                            <span className="unit">원</span>
                                                          </div>
                                                        </div>
                                                      )
                                                    }
                                                    return null;
                                                  })}
                                                </div>
                                                <div className="iao-detail__total">
                                                  <span className="iao-detail__total-label">총 결제 금액</span>
                                                  <span className="iao-detail__total-value">
                                                    {new Intl.NumberFormat('ko-KR').format(this.totalOrderInfo.orderAmount)}<span className="unit">원</span>
                                                  </span>
                                                </div>
                                              </div>
                                            )}

                                          </div>
                                      )}

                                      {/* 환불 금액 상세 박스는 정기 결제 상세 카드 안의 sub-section으로 통합되었습니다. */}


                                      {/* 주문자 정보는 우측 결제 하기 패널 위로 이동되었습니다. */}

                                      {/* 약관 동의 + 결제/무료 신청 CTA는 우측 4단계 패널로 통합되었습니다. */}

                                    </>
                                ) : null}

                              </form>

                              {/* === 약관 본문 모달 === */}
                              {(() => {
                                const m = this.termsModal;
                                if (!m.open) return null;
                                const titleByType = {
                                  service: '서비스 이용약관',
                                  private: '개인정보 이용약관',
                                  noRefund: '할인 상품 환불 불가'
                                };
                                const isAgreed = (
                                  m.type === 'service' ? !!this.totalOrderInfo.serviceAgree :
                                  m.type === 'private' ? !!this.totalOrderInfo.privateAgree :
                                  m.type === 'noRefund' ? !!this.noRefundAgg : false
                                );
                                const onToggle = (event) => {
                                  if (m.type === 'service')      this.onChangeChecked(event, this.totalOrderInfo, ['serviceAgree']);
                                  else if (m.type === 'private') this.onChangeChecked(event, this.totalOrderInfo, ['privateAgree']);
                                  else if (m.type === 'noRefund') this.onChangeChecked(event, this, ['noRefundAgg']);
                                };
                                return (
                                  <Modal open={m.open}
                                         toggle={() => {}}
                                         size="lg"
                                         className="iao-terms-modal">
                                    <ModalHeader toggle={this.closeTermsModal}>
                                      <span className="iao-terms-modal__title">
                                        <FeatherIcon icon="file-text" size="16"/> {titleByType[m.type] || '약관'}
                                      </span>
                                    </ModalHeader>
                                    <ModalBody>
                                      <div className="iao-terms-modal__content">
                                        {m.type === 'service' && (
                                          <div dangerouslySetInnerHTML={{__html: TermsAndPrivacy.termsOfService}}/>
                                        )}
                                        {m.type === 'private' && (
                                          <div dangerouslySetInnerHTML={{__html: TermsAndPrivacy.privacyPolicy}}/>
                                        )}
                                        {m.type === 'noRefund' && (
                                          <div>
                                            <strong>제 25 조 (할인 상품 환불 불가)</strong><br/>
                                            ① "회사"는 특별 할인, 기간 한정 이벤트, 프로모션 등으로 제공되는 서비스 상품(이하 "할인 상품")에 대해, 이용자가 구매 시 명시된 환불 제한 조건에 따라 환불을 제한할 수 있습니다.<br/>
                                            ② "회원"이 할인 상품을 구매하거나 신청하는 경우, 환불 불가 조건에 사전 고지되었으며 이에 동의한 것으로 간주됩니다.<br/>
                                            ③ 할인 상품은 결제 또는 이용 개시 시점(콘텐츠 이용, 기능 활성화, 접근 발생 등 포함) 이후에는 단순 변심이나 사용 의사 변경에 따른 환불이 불가합니다.<br/>
                                            ④ 서비스 제공 중 발생하는 일시적인 오류, 시스템 버그 또는 일과성 장애 등은 회사가 자체적으로 복구 또는 기간 연장 등의 방법으로 대응하며, 이로 인한 환불은 제공되지 않습니다.<br/>
                                          </div>
                                        )}
                                      </div>
                                      <div className="iao-terms-modal__footer-action">
                                        <span className="iao-terms-modal__footer-action-label">
                                          내용을 확인하셨다면 동의해주세요.
                                        </span>
                                        <FormGroup style={{margin: 0}}>
                                          <FormCheckbox toggle
                                                        checked={isAgreed}
                                                        onChange={onToggle}>
                                            {isAgreed ? '동의함' : '동의'}
                                          </FormCheckbox>
                                        </FormGroup>
                                      </div>
                                    </ModalBody>
                                  </Modal>
                                );
                              })()}

                              {/* === 결제갱신 안내 모달 === */}
                              <Modal open={this.cardRenewModal.open}
                                     toggle={() => {}}
                                     size="md"
                                     className="iao-terms-modal">
                                <ModalHeader toggle={this.closeCardRenewModal}>
                                  <span className="iao-terms-modal__title">
                                    <FeatherIcon icon="credit-card" size="16"/> 결제갱신 안내
                                  </span>
                                </ModalHeader>
                                <ModalBody>
                                  <div className="iao-terms-modal__content" style={{lineHeight: 1.7}}>
                                    <p style={{margin: '0 0 12px', fontWeight: 600, color: '#16202D'}}>
                                      결제갱신 진행 전, 기존에 연동된 카드의 해지가 필요합니다.
                                    </p>
                                    <p style={{margin: '0 0 12px', color: '#475569'}}>
                                      자세한 절차는 아래 메뉴얼 페이지를 반드시 확인 후 진행해 주세요.<br/>
                                      절차를 따르지 않을 경우 중복 결제가 발생할 수 있습니다.
                                    </p>
                                    <a href="https://onnomad.co.kr/manual/review-solution-onreple?ch=6968913a42b69734a5432550&sec=69ae784b3ae08be6f4790f40"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       style={{display: 'inline-flex', alignItems: 'center', gap: 6, color: '#2563EB', fontWeight: 600}}>
                                      기존 연동 카드 해지 안내 메뉴얼 열기
                                      <FeatherIcon icon="external-link" size="13"/>
                                    </a>
                                  </div>
                                  <div className="iao-terms-modal__footer-action" style={{justifyContent: 'flex-end', gap: 8}}>
                                    <Button theme="light" onClick={this.closeCardRenewModal}>취소</Button>
                                    <Button theme="primary" onClick={this.confirmCardRenew}>
                                      확인했습니다, 진행하기
                                    </Button>
                                  </div>
                                </ModalBody>
                              </Modal>

                              {/* === 쇼핑몰 선택 모달 === */}
                              <Modal open={this.isShopSelectOpen}
                                     toggle={() => {}}
                                     size="lg"
                                     className="iao-shop-modal">
                                <ModalHeader toggle={() => { this.isShopSelectOpen = false; }}>
                                  <span className="iao-shop-modal__title">
                                    <FeatherIcon icon="shopping-bag" size="16"/> 결제할 쇼핑몰 선택
                                  </span>
                                </ModalHeader>
                                <ModalBody>
                                  <p className="iao-shop-modal__hint">
                                    <FeatherIcon icon="info" size="13"/>
                                    <span>여러 쇼핑몰을 한번에 결제할 수 있습니다. 이미 추가된 쇼핑몰은 "추가됨"으로 표시됩니다.</span>
                                  </p>
                                  <div className="channel-grid">
                                    {this.shops.map((item, i) => {
                                      const alreadyAdded = !!(this.totalOrderInfo.orders && this.totalOrderInfo.orders[item.platformShopNo]);
                                      return (
                                          <div key={i}
                                               className={`channel-card${(!item.useExpiryDate || moment().isAfter(item.useExpiryDate) || item.orderType === "free") ? "" : " isPaid"}`}>
                                            <div className="channel-flag">
                                              {item.languageCode === "ko_KR" && "🇰🇷"}
                                              {item.languageCode === "en_US" && "🇺🇸"}
                                              {item.languageCode === "zh_CN" && "🇨🇳"}
                                              {item.languageCode === "zh_TW" && "🇹🇼"}
                                              {item.languageCode === "ja_JP" && "🇯🇵"}
                                              {item.languageCode === "vi_VN" && "🇻🇳"}
                                            </div>
                                            <div className="channel-name">{item.shopName}</div>
                                            <div className="channel-description">{item.primaryDomain ? item.primaryDomain : item.domain}</div>
                                            {alreadyAdded ? (
                                                <button className="enter-btn" type="button" disabled>추가됨</button>
                                            ) : (
                                                <button className="enter-btn" type="button" onClick={() => {
                                                  this.onSelectShop(item.platformShopNo);
                                                  this.isShopSelectOpen = false;
                                                }}>선택하기</button>
                                            )}
                                          </div>
                                      );
                                    })}
                                  </div>
                                </ModalBody>
                              </Modal>

                                </div>{/* /.iao-layout__main */}

                                {/* === 우측 column — 주문자 정보 + 결제 하기 === */}
                                <div className="iao-layout__side">

                              {/* === 주문자 정보 (선택된 쇼핑몰이 있을 때만) === */}
                              {this.totalOrderInfo && this.totalOrderInfo.orders && Object.keys(this.totalOrderInfo.orders).length > 0 && (
                                <div className="iao-orderer iao-orderer--side">
                                  <div className="iao-orderer__head">
                                    <h3>
                                      <span className="iao-step-num">3</span>
                                      <FeatherIcon icon="user" size="16"/> 주문자 정보
                                    </h3>
                                  </div>
                                  <div className="iao-orderer__grid">
                                    <div className="iao-orderer__field">
                                      <label className="iao-orderer__label">쇼핑몰 이름</label>
                                      <input name="storeName" type="text" className="iao-orderer__input"
                                             defaultValue={this.totalOrderInfo.storeName} disabled={true}/>
                                    </div>
                                    <div className="iao-orderer__field">
                                      <label className="iao-orderer__label iao-orderer__label--required">관리자 이름</label>
                                      <input name="userName" type="text" className="iao-orderer__input"
                                             placeholder="홍길동"
                                             defaultValue={this.totalOrderInfo.userName}
                                             onChange={e => this.onChangeValue(e)}/>
                                    </div>
                                    <div className="iao-orderer__field">
                                      <label className="iao-orderer__label iao-orderer__label--required">담당자 핸드폰</label>
                                      <input name="tel" type="text" className="iao-orderer__input"
                                             placeholder="010-0000-0000"
                                             defaultValue={this.totalOrderInfo.tel}
                                             onChange={e => this.onChangeValue(e)}/>
                                    </div>
                                    <div className="iao-orderer__field">
                                      <label className="iao-orderer__label iao-orderer__label--required">담당자 이메일</label>
                                      <input name="email" type="text" className="iao-orderer__input"
                                             placeholder="email@example.com"
                                             defaultValue={this.totalOrderInfo.email}
                                             onChange={e => this.onChangeValue(e)}/>
                                    </div>
                                    <div className="iao-orderer__field iao-orderer__field--full">
                                      <p className="iao-orderer__helper iao-orderer__helper--notice">
                                        <FeatherIcon icon="alert-circle" size="11"/>
                                        <span>
                                          담당자 핸드폰 번호와 이메일 주소로 온리플 서비스 이용 및 <strong>주문 관련 안내</strong>가 전송됩니다.
                                          잘못된 정보를 입력하거나 안내 내용을 확인하지 못해 발생하는 불이익에 대해 <strong>본사는 책임지지 않습니다.</strong>
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="iao-orderer__confirm">
                                    {this.isOrdererConfirmed ? (
                                      <button type="button" className="iao-orderer__confirm-btn iao-orderer__confirm-btn--done" disabled>
                                        <FeatherIcon icon="check-circle" size="14"/>
                                        주문자 정보 확인 완료
                                      </button>
                                    ) : (
                                      <button type="button" className="iao-orderer__confirm-btn"
                                              onClick={this.confirmOrderer}>
                                        <FeatherIcon icon="check" size="14"/>
                                        확인 완료
                                      </button>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* === Sticky 결제 요약 패널 (선택된 쇼핑몰 + 주문자 정보 확인 완료 시) === */}
                              {this.totalOrderInfo && this.totalOrderInfo.orders && Object.keys(this.totalOrderInfo.orders).length > 0 && this.isOrdererConfirmed && (() => {
                                const orderEntries = Object.keys(this.totalOrderInfo.orders)
                                  .map(k => ({key: k, info: this.totalOrderInfo.orders[k]}))
                                  .filter(e => e.info && e.info.plan);
                                const isAuto = this.totalOrderInfo.payType === 'autoPayment';
                                const isFree = this.totalOrderInfo.payType === 'free' || this.isEventFree;
                                // 환불 정책 동의 — 유료 결제에서만 필수
                                const showRefundTerm = !isFree;
                                const allAgreed = isFree
                                  ? !!(this.totalOrderInfo.serviceAgree && this.totalOrderInfo.privateAgree)
                                  : !!(this.totalOrderInfo.serviceAgree &&
                                       this.totalOrderInfo.privateAgree &&
                                       this.noRefundAgg);
                                // 결제 가능 조건 — 약관 동의 + 주문자 정보 확인 완료
                                const canPay = allAgreed && this.isOrdererConfirmed;
                                return (
                                  <aside className="iao-summary" aria-label={isFree ? '무료 이용 신청' : '결제 하기'}>
                                    <div className="iao-summary__head">
                                      <div className="iao-summary__head-title">
                                        <span className="iao-step-num iao-step-num--inverted">4</span>
                                        <FeatherIcon icon={isFree ? 'gift' : 'credit-card'} size="14"/>
                                        {isFree ? `무료 이용 신청 (${orderEntries.length}개 쇼핑몰)` : `결제 하기 (${orderEntries.length}개 쇼핑몰)`}
                                      </div>
                                      <div className="iao-summary__head-sub">{isFree ? '14일 무료 체험' : (isAuto ? '월 정기 결제' : '일회 결제')}</div>
                                    </div>
                                    <div className="iao-summary__body">
                                      {orderEntries.map((e, i) => {
                                        const shop = this.shopsObj[e.info.shopNo];
                                        const name = shop ? shop.shopName : `쇼핑몰 ${e.info.shopNo}`;
                                        const amt = e.info.orderAmount || (e.info.plan && e.info.plan.price) || 0;
                                        const period = e.info.payment && e.info.payment.period;
                                        const showPeriod = !isAuto && e.info.startDate && period;
                                        const periodEnd = showPeriod ? moment(e.info.startDate).add(period, 'months') : null;
                                        return (
                                          <div key={i} className="iao-summary__shop-row">
                                            <div className="iao-summary__shop-row-info">
                                              <span className="iao-summary__shop-row-name">{name}</span>
                                              {showPeriod && (
                                                <span className="iao-summary__shop-row-period">
                                                  <FeatherIcon icon="calendar" size="11"/>
                                                  {moment(e.info.startDate).format('YYYY.MM.DD')} ~ {periodEnd.format('YYYY.MM.DD')}
                                                  <span className="iao-summary__shop-row-period-months">({period}개월)</span>
                                                </span>
                                              )}
                                            </div>
                                            <span className="iao-summary__shop-row-amt">
                                              {new Intl.NumberFormat('ko-KR').format(amt)}원
                                            </span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                    <div className="iao-summary__total">
                                      <div className="iao-summary__total-label">
                                        {isFree ? '무료 체험 기간' : (isAuto ? '월 구독 결제 금액' : '총 결제 금액')}
                                      </div>
                                      <div className="iao-summary__total-value">
                                        {isFree ? (
                                          <>14<sup>일</sup></>
                                        ) : (
                                          <>
                                            {new Intl.NumberFormat('ko-KR').format(this.totalOrderInfo.orderAmount || 0)}<sup>원</sup>
                                            {isAuto && <sup style={{marginLeft: 4}}>/ 월</sup>}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {/* 일시불 결제 — 환불 불가 안내 */}
                                    {!isFree && !isAuto && (
                                      <div className="iao-summary__norefund">
                                        <FeatherIcon icon="alert-circle" size="12"/>
                                        <span>일시불 결제는 결제 완료 후 <strong>환불이 불가</strong>합니다.</span>
                                      </div>
                                    )}
                                    {/* 약관 동의 영역 — 제목 클릭 시 모달, 우측 토글 */}
                                    <div className="iao-summary__terms">
                                      <div className="iao-summary__terms-head">약관 동의</div>
                                      <div className="iao-summary__terms-row">
                                        <button type="button" className="iao-summary__terms-row-title"
                                                onClick={() => this.openTermsModal('service')}>
                                          <FeatherIcon icon="file-text" size="13"/>
                                          서비스 이용약관
                                          <span className="iao-summary__terms-row-required">(필수)</span>
                                        </button>
                                        <FormCheckbox toggle small
                                                      checked={this.totalOrderInfo.serviceAgree || false}
                                                      onChange={event => this.onChangeChecked(event, this.totalOrderInfo, ['serviceAgree'])}/>
                                      </div>
                                      <div className="iao-summary__terms-row">
                                        <button type="button" className="iao-summary__terms-row-title"
                                                onClick={() => this.openTermsModal('private')}>
                                          <FeatherIcon icon="file-text" size="13"/>
                                          개인정보 이용약관
                                          <span className="iao-summary__terms-row-required">(필수)</span>
                                        </button>
                                        <FormCheckbox toggle small
                                                      checked={this.totalOrderInfo.privateAgree || false}
                                                      onChange={event => this.onChangeChecked(event, this.totalOrderInfo, ['privateAgree'])}/>
                                      </div>
                                      {showRefundTerm && (
                                        <div className="iao-summary__terms-row">
                                          <button type="button" className="iao-summary__terms-row-title"
                                                  onClick={() => this.openTermsModal('noRefund')}>
                                            <FeatherIcon icon="alert-circle" size="13"/>
                                            환불 정책 동의
                                            <span className="iao-summary__terms-row-required">(필수)</span>
                                          </button>
                                          <FormCheckbox toggle small
                                                        checked={this.noRefundAgg || false}
                                                        onChange={event => this.onChangeChecked(event, this, ['noRefundAgg'])}/>
                                        </div>
                                      )}
                                    </div>

                                    <div className="iao-summary__cta-area">
                                      <button type="button"
                                              className="iao-cta"
                                              disabled={!canPay}
                                              onClick={(event) => isFree ? this.onFreeSubmit(event) : this.onSubmit(event)}>
                                        {canPay
                                          ? (isFree ? '무료로 사용하기' : '주문하기')
                                          : !this.isOrdererConfirmed
                                            ? (isFree ? '주문자 정보 확인 후 신청 가능' : '주문자 정보 확인 후 주문 가능')
                                            : (isFree ? '약관 동의 후 신청 가능' : '약관 동의 후 주문 가능')}
                                      </button>
                                      <div className="iao-summary__cta-hint">
                                        <FeatherIcon icon="shield" size="11"/>
                                        카페24 안전결제로 보호되는 거래입니다.
                                      </div>
                                    </div>
                                  </aside>
                                );
                              })()}

                                </div>{/* /.iao-layout__side */}
                              </div>{/* /.iao-layout */}

                            </div>
                          </>) : (
                          <></>)
                      }
                    </>) : <p className='empty'><a href='/signin'>로그인하세요.</a></p>}
              </div>
          )}
          <ModalLoading isLoading={this.isLoading}/>
        </>
    )
  }
}

export default InAppOrder;
